import  request  from "../utils/requestdata";
// 上传升级安装包
// /pc/system/productVersion/uploadPackage
export function uploadPackage(data){
    return request({
        method:'POST',
        url:'/nk/choose/file/uploadMiniFile',
        data:data
    })
}




// WEBPACK FOOTER //
// ./src/api/proddata.js